import React from "react";
import { Box, Grid2 } from "@mui/material";
import Departments from "./Departments/Departments";
import Teams from "./Teams/Teams";

const Index = () => {
  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Departments />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Teams />
        </Grid2>
      </Grid2>
    </>
  );
};

export default Index;
